import { useFormContext } from 'react-hook-form';
import { Icon } from '@scripsteam/scrips-signal-ds';
import { TextArea as Textarea } from '@scripsteam/scrips-signal-ds';
import type { AppointmentFormValues } from '@/types/appointment-form';
// PROD-2743 design sheet §3 (icons): DS names ON only (?ef=frameV2); OFF keeps today's lucide icon, unchanged.

// Named `AppointmentNoteSection`, not `NoteSection`: signal-ds 2.19 exports its own `NoteSection` (the
// encounter note's S·O·A·P section), and the DS shadow guard reads the same name as a duplicate. This is a
// different component (the appointment's internal staff note), so it takes a name of its own.
export function AppointmentNoteSection() {
  const { watch, setValue } = useFormContext<AppointmentFormValues>();
  const comment = watch('comment') ?? '';

  return (
    <div className="booking-section" data-slot="booking-section">
      {/* Label row + remove (×). Flutter's InternalNoteWidget is a plain
          labeled text field — no AI affordance. */}
      <div className="flex items-center justify-between mb-2">
        <label className="booking-section-label">
          Internal note
        </label>
        <button
          type="button"
          onClick={() => setValue('comment', null)}
          className="booking-icon-btn"
          aria-label="Remove note"
        >
          <Icon name="close" size={16} aria-hidden />
        </button>
      </div>

      <Textarea
        placeholder="Add a note (visible to staff only)..."
        value={comment}
        onChange={(e) => setValue('comment', e.target.value)}
        className="text-sm min-h-15 resize-none"
        maxLength={500}
      />
      <p className="text-xs text-text-hint mt-1 text-right">{comment.length}/500</p>
    </div>
  );
}
